var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResums(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "resums",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110.556,
    height: 110.508,
    viewBox: "0 0 110.556 110.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.1,
    y1: 0.555,
    x2: 1.152,
    y2: 0.54,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b7ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_204",
    "data-name": "Grupo 204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_500",
    "data-name": "Caminho 500",
    d: "M0,62.151a6.54,6.54,0,0,0,.579-.456Q12.372,49.912,24.156,38.12c.127-.127.243-.263.423-.458-.263-.285-.513-.57-.779-.836Q13.692,26.714,3.583,16.6c-3.851-3.853-3.825-8.581,0-12.467C5.1,2.6,6.693,1.228,8.9.855a8.213,8.213,0,0,1,7.548,2.515q10.138,10.158,20.29,20.3c.279.279.513.6.739.871Q49.882,12.141,62.019,0c16.2,16.2,32.233,32.236,48.537,48.539a5.29,5.29,0,0,0-1,.667q-30.228,30.2-60.434,60.425c-.274.274-.509.583-.763.877h-.215a7.408,7.408,0,0,0-.476-.568Q24.119,86.386.568,62.84c-.173-.173-.379-.318-.568-.474Zm48.247,43.227,57.111-57.109q-21.534-21.54-43.087-43.1L40.12,27.321a6.139,6.139,0,0,1,.91.649q5.013,4.984,9.992,10a2.682,2.682,0,0,1,.726,1.368c.55,3.551,1.044,7.112,1.546,10.671.173,1.224.32,2.45.491,3.768-5.051-.719-9.924-1.4-14.79-2.132a2.208,2.208,0,0,1-1.04-.691q-5.017-4.984-10-9.992c-.27-.27-.553-.524-.682-.647Q16.153,51.437,5.237,62.357l43.014,43.021Zm-.708-66.127a10.452,10.452,0,0,1-.932-.748C36.032,27.972,25.4,17.5,14.93,6.862c-3-3.046-5.945-3.5-9.1.1-1.932,2.2-2.051,4.713,0,6.809q3.467,3.549,6.963,7.068Q25.714,33.777,38.655,46.7c.246.246.5.474.7.66l2.858-2.752Q28.509,30.9,14.9,17.3l2.472-2.605Q31.114,28.441,44.7,42.025l2.844-2.772Zm-4.29,9.472c2.208.314,4.252.6,6.421.912-.32-2.191-.618-4.244-.95-6.511-1.825,1.836-3.469,3.487-5.112,5.141-.1.1-.171.215-.362.456Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_501",
    "data-name": "Caminho 501",
    d: "M182.495,389.011c1.434,1.443,2.969,3,4.513,4.542,1.276,1.276,2.092,1.276,3.371,0q4.388-4.378,8.759-8.77a6.413,6.413,0,0,0,.658-.943l2.581,2.627c-.105.118-.3.364-.518.581q-4.533,4.54-9.07,9.068c-2.6,2.583-5.623,2.561-8.237-.039-1.551-1.544-3.1-3.086-4.632-4.608.847-.809,1.638-1.566,2.57-2.458Z",
    transform: "translate(-140.463 -299.662)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_502",
    "data-name": "Caminho 502",
    d: "M128.243,242.683q-8.615-8.615-17.393-17.391l2.279-2.2q8.658,8.658,17.424,17.426Z",
    transform: "translate(-86.54 -174.165)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_503",
    "data-name": "Caminho 503",
    d: "M86.43,249.546c.763-.757,1.526-1.511,2.175-2.156L106.113,264.9l-2.165,2.154Z",
    transform: "translate(-67.475 -193.136)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_504",
    "data-name": "Caminho 504",
    d: "M82.591,288.686l-2.287,2.2L62.93,273.514c.691-.7,1.491-1.5,2.237-2.254q8.642,8.642,17.424,17.424Z",
    transform: "translate(-49.129 -211.771)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_505",
    "data-name": "Caminho 505",
    d: "M285.854,67.186c-.649.621-1.447,1.384-2.154,2.057q-6.043-6.043-12.18-12.185l2.14-2.068Z",
    transform: "translate(-211.974 -42.93)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_506",
    "data-name": "Caminho 506",
    d: "M261.8,90.856c-.739.7-1.518,1.436-2.2,2.077L247.39,80.722l2.14-2.132c4.068,4.066,8.127,8.123,12.27,12.266Z",
    transform: "translate(-193.136 -61.355)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_507",
    "data-name": "Caminho 507",
    d: "M223.222,104.743c.768-.836,1.515-1.649,2.228-2.423q6.151,6.155,12.213,12.215l-2.292,2.347q-6.132-6.128-12.152-12.141Z",
    transform: "translate(-174.267 -79.881)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_508",
    "data-name": "Caminho 508",
    d: "M345.149,161.084l.022-.022q1.148-1.148,2.3-2.3l-.035-.033q-4.925-4.924-9.882-9.884h0l-.007-.007-2.32-2.32-.092.1,0,0-9.816,9.823,0,0-.1.107q-1.109,1.112-2.222,2.224c.031.031.061.061.092.09h0l9.829,9.82,0,0,.366.357c.654.651,1.3,1.3,1.961,1.958l.112-.114q4.885-4.885,9.805-9.8h0Zm-9.919,5.276-7.595-7.6q3.783-3.783,7.592-7.59l7.595,7.588Z",
    transform: "translate(-252.157 -114.387)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_509",
    "data-name": "Caminho 509",
    d: "M270.549,234.544l.022-.022q1.148-1.148,2.3-2.3l-.035-.033q-4.924-4.925-9.882-9.884h0l-.007-.007-2.32-2.32-.092.1,0,0-9.816,9.823,0,0-.1.107q-1.109,1.112-2.222,2.224c.031.031.061.061.092.09h0l9.829,9.82,0,0,.366.357c.654.651,1.3,1.3,1.961,1.958l.112-.114q4.885-4.885,9.805-9.8h0Zm-9.919,5.276-7.595-7.6q3.783-3.783,7.592-7.59l7.595,7.588Z",
    transform: "translate(-193.917 -171.737)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_510",
    "data-name": "Caminho 510",
    d: "M192.659,313.584l.022-.022q1.148-1.148,2.3-2.3l-.035-.033q-4.925-4.924-9.882-9.884h0l-.007-.007-2.32-2.32-.092.1,0,0-9.816,9.823,0,0-.1.107q-1.109,1.112-2.222,2.224c.031.031.061.061.092.09h0l9.829,9.82,0,0,.366.357c.654.651,1.3,1.3,1.961,1.958l.112-.114q4.885-4.885,9.805-9.8h0Zm-9.919,5.276-7.595-7.6q3.783-3.783,7.592-7.59l7.595,7.588Z",
    transform: "translate(-133.109 -233.443)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_511",
    "data-name": "Caminho 511",
    d: "M281.75,362.866c1.108-1.112,2.219-2.226,3.268-3.276l2.344,2.338c-1.031.989-2.182,2.1-3.366,3.233l-2.243-2.294Z",
    transform: "translate(-219.961 -280.73)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResums);
export default __webpack_public_path__ + "static/media/resums.6c55c72fbb08dbdd584f47fe761dfb19.svg";
export { ForwardRef as ReactComponent };